import { Message } from "./Message"
import { StatusUpdateMessage } from "./StatusUpdateMessage"

// How long a mechanic gets to regret a chat message before it is delivered.
export const UNDO_SEND_WINDOW_MS = 30_000

export interface PendingScheduledMessage {
  scheduledSendAt: Date
  scheduledSendGroupId: string
}

/**
 * A real chat message still waiting out its undo window. StatusUpdateMessage is
 * excluded because it is synthesised from an event rather than stored, so it
 * has no content, attachments or scheduling of its own.
 */
export type PendingMessage = Exclude<Message, StatusUpdateMessage> &
  PendingScheduledMessage

/**
 * True while a message has been persisted but not yet delivered.
 *
 * The `in` check is load-bearing: StatusUpdateMessage is part of the Message
 * union but extends StatusUpdateEvent rather than BaseMessage, so it has no
 * scheduledSendAt at all.
 */
export const isPendingScheduledMessage = (
  message: Message,
): message is PendingMessage =>
  "scheduledSendAt" in message &&
  message.scheduledSendAt !== null &&
  message.scheduledSendGroupId !== null
